import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Memini ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Messages ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Channels ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Logout")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Inloggen ")
const _hoisted_6 = {
  href: "mailto:info@memini.ga",
  style: {"text-decoration":"none"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Contact", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("info@memini.ga")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, { view: "hHh lpR fFf" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_header, { elevated: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                icon: $setup.matMenu,
                onClick: $setup.toggleLeftDrawer,
                "aria-label": "Toggle menu",
                dense: "",
                flat: "",
                round: ""
              }, null, 8, ["icon", "onClick"]),
              _createVNode(_component_q_toolbar_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_drawer, {
        "show-if-above": "",
        modelValue: $setup.leftDrawerOpen,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.leftDrawerOpen) = $event)),
        side: "left",
        bordered: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item, {
                clickable: "",
                to: "/",
                exact: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { avatar: "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, { name: $setup.matChatBubbleOutline }, null, 8, ["name"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              ($setup.currentUser)
                ? (_openBlock(), _createBlock(_component_q_item, {
                    key: 0,
                    clickable: "",
                    to: "/channels"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, { name: $setup.matCategory }, null, 8, ["name"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_q_separator, { spaced: "" }),
              ($setup.currentUser)
                ? (_openBlock(), _createBlock(_component_q_item, {
                    key: 1,
                    clickable: "",
                    onClick: $setup.onLogout
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, { name: $setup.matLogout }, null, 8, ["name"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_label, { caption: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString($setup.currentUser.email), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_q_item, {
                    key: 2,
                    clickable: "",
                    to: "/login"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { avatar: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, { name: $setup.matLogin }, null, 8, ["name"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })),
              _createElementVNode("a", _hoisted_6, [
                _createVNode(_component_q_item, { clickable: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, { avatar: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, { name: $setup.matContactSupport }, null, 8, ["name"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_label, { caption: "" }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_page_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}